// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3KbdW","image":"Header_image__24KTu","name":"Header_name__1koQ7","info":"Header_info__3GCI5","infoRow":"Header_infoRow__2wSfI"};